import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-black py-16 px-4 pt-[0px] pb-[0px]" data-id="element-287">
      <div className="max-w-3xl mx-auto text-center" data-id="element-288">
        <h2 className="text-2xl sm:text-3xl font-bold text-white mb-10" data-id="element-289">
          Si sos profe de Baby Fútbol en Argentina,
          <br data-id="element-290" />
          <span className="text-[#00C853]" data-id="element-291">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-4 text-left mb-12" data-id="element-292">
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-293">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-294">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-295">
              Domingo a la noche buscando ejercicios en YouTube que nunca quedan
              bien y no se adaptan al pibe argentino de club de barrio
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-296">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-297">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-298">
              Llegás al lunes con algo que "más o menos sirve" y durante la
              clase te das cuenta que le falta progresión, variantes y objetivo
              claro
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-299">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-300">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-301">
              Tenés que armar planificaciones para la coordinación del club a
              las corridas, sin saber si están bien armadas para la edad
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-302">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-303">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-304">
              Tus ejercicios son siempre los mismos o siempre inventados porque
              no tenés un banco de sesiones con correcciones incluidas
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-305">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-306">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-307">
              Cuando el tema es difícil —el pressing, las transiciones, el 1 vs
              1 bajo presión— no sabés cómo enseñarlo sin perder al grupo
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-308">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-309">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-310">
              Tenés jugadores con niveles distintos en el mismo grupo y no tenés
              material diferenciado: entrenás para el promedio y perdés a todos
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-311">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-312">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-313">
              El material que encontrás online está pensado para academias
              profesionales con staff, no para vos solo con 20 pibes y 12 conos
            </p>
          </div>
          <div className="flex items-start gap-4 bg-[#FF0000]/10 border border-[#FF0000]/30 rounded-xl p-4" data-id="element-314">
            <span className="text-[#FF0000] text-2xl flex-shrink-0" data-id="element-315">❌</span>
            <p className="text-white text-lg font-medium" data-id="element-316">
              Llegás al fin de semana agotado y el domingo volvés a empezar el
              ciclo de buscar, armar e improvisar
            </p>
          </div>
        </div>

        <p className="text-[#00C853] text-2xl sm:text-3xl font-black mb-8" data-id="element-317">
          ¿Cuántos domingos más vas a perder haciendo lo mismo?
        </p>

        {/* Green divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#00C853] to-transparent w-full" data-id="element-318" />
      </div>
    </section>;
}